// Imports need to be separator to avoid circular dependencies
import { BaseModel } from "../../../models"
import { Test } from "../test/test"

export class TestGroup extends BaseModel {
  public name: string
  public tests: Test[]

  constructor() { super() }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/data/models/test-group/test-group.ts